import {
  createStyles,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  // Toolbar,
  // Typography,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
  })
);
// const EnhancedTableToolbar = () => {
//   return <Toolbar></Toolbar>;
// };

interface props {
  cellsCount: number;
  rowsCount: number;
}

const SkeletonCustomTable = ({ cellsCount, rowsCount }: props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
          >
            <TableHead>
              <TableRow>
                {Array(cellsCount)
                  .fill(1)
                  .map((item, id) => (
                    <TableCell key={id} align="center">
                      <Skeleton
                        variant="text"
                        width={80}
                        height={14}
                        style={{ margin: "0 auto" }}
                      />
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array(rowsCount)
                .fill(1)
                .map((item, id) => (
                  <TableRow key={id}>
                    {Array(cellsCount)
                      .fill(1)
                      .map((item, id) => (
                        <TableCell key={id} align="center">
                          <Skeleton
                            variant="text"
                            width={80}
                            height={14}
                            style={{ margin: "0 auto" }}
                          />
                        </TableCell>
                      ))}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default SkeletonCustomTable;
